import auth0JS from "auth0-js";

class Auth {
  auth0 = new auth0JS.WebAuth({
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    clientID: process.env.REACT_APP_AUTH0_CLIENTID,
    callbackUrl: process.env.REACT_APP_AUTH0_CALLBACKURL,
    audience: "https://api.platform.samba.tv",
    redirectUri: process.env.REACT_APP_AUTH0_CALLBACKURL,
    responseType: "token id_token",
    realm: "Username-Password-Authentication",
    scope: "openid profile"
  });

  authorize() {
    this.auth0.authorize({ prompt: "login", connection: "google-oauth2" });
  }

  login(body, callback) {
    this.auth0.login(body, callback);
  }

  handleAuthentication(callback) {
    this.auth0.parseHash(callback);
  }

  getTokenSilently() {
    return this.auth0.getTokenSilently();
  }
}

export default Auth;
